/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportedProblemDraft } from './ImportedProblemDraft';
import {
    ImportedProblemDraftFromJSON,
    ImportedProblemDraftFromJSONTyped,
    ImportedProblemDraftToJSON,
    ImportedProblemDraftToJSONTyped,
} from './ImportedProblemDraft';

/**
 * The competition name, problem drafts and round-level warnings of an imported round.
 * @export
 * @interface CompetitionPdfImport
 */
export interface CompetitionPdfImport {
    /**
     * 
     * @type {string}
     * @memberof CompetitionPdfImport
     */
    name: string;
    /**
     * 
     * @type {Array<ImportedProblemDraft>}
     * @memberof CompetitionPdfImport
     */
    problems: Array<ImportedProblemDraft>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompetitionPdfImport
     */
    warnings?: Array<string>;
}

/**
 * Check if a given object implements the CompetitionPdfImport interface.
 */
export function instanceOfCompetitionPdfImport(value: object): value is CompetitionPdfImport {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('problems' in value) || value['problems'] === undefined) return false;
    return true;
}

export function CompetitionPdfImportFromJSON(json: any): CompetitionPdfImport {
    return CompetitionPdfImportFromJSONTyped(json, false);
}

export function CompetitionPdfImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionPdfImport {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'problems': ((json['problems'] as Array<any>).map(ImportedProblemDraftFromJSON)),
        'warnings': json['warnings'] == null ? undefined : json['warnings'],
    };
}

export function CompetitionPdfImportToJSON(json: any): CompetitionPdfImport {
    return CompetitionPdfImportToJSONTyped(json, false);
}

export function CompetitionPdfImportToJSONTyped(value?: CompetitionPdfImport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'problems': ((value['problems'] as Array<any>).map(ImportedProblemDraftToJSON)),
        'warnings': value['warnings'],
    };
}

